import type { Workflow } from '../../model';

/**
 * Apply document signatures types on workflow.
 */
export const applyDocumentSignaturesTypesOnWorkflow = (
  workflow: Workflow,
  signeSignatureCode: string,
): Workflow => ({
  ...workflow,
  nodes: (workflow.nodes || []).map(node => {
    if (!['signe', 'accept'].includes(node.type)) {
      return node;
    }

    return {
      ...node,
      parameters: {
        participants: (node.parameters.participants || []).map((p: any) => {
          if (p.type === 'participant-user') {
            return {
              ...p,
              parameters: {
                ...p.parameters,
                signMethod:
                  node.type === 'accept' ? 'SIMPLE' : signeSignatureCode,
              },
            };
          }
          if (p.type === 'participant-group') {
            return {
              type: p.type,
              parameters: {
                ...p.parameters,
                participants: p.parameters.participants.map((u: any) => ({
                  ...u,
                  parameters: {
                    ...u.parameters,
                    signMethod:
                      node.type === 'accept' ? 'SIMPLE' : signeSignatureCode,
                  },
                })),
              },
            };
          }
          return p;
        }),
      },
    };
  }),
});
